import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { TransactionHistoryTabState } from 'src/domains/players/webview/components/Account/transactionHistoryTab/TransactionHistoryTab.state';
import { BetsListBet, TransactionHistoryItemWrapper } from './TransactionsList.style';
import { NetDepositEmail, NetDepositEmailInformation, NetDepositText } from './NetDeposit.style';
import { TransactionNetDepositCurrency } from './Transaction.style';
import { DateTime } from 'src_common/utils/time/time';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { UsersState } from 'src/domains/players/state/UsersState';

interface PropsType {
    state: TransactionHistoryTabState;
}

export const NetDeposit = observer('NetDeposit', (props: PropsType) => {
    const { collection } = props.state;
    const range = collection.range;

    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const usersState = UsersState.get(common);

    const {
        accountHelperMail,
        componentVariants: { accountSectionVariant },
    } = configState;

    const totalValue =
        collection.netDeposit?.aggregations.totalValue === undefined
            ? null
            : collection.netDeposit.aggregations.totalValue;

    const rangeFrom = range?.from;
    const startDate = rangeFrom === undefined ? DateTime.from('2018-01-01') : DateTime.from(rangeFrom);
    const startDateForView = startDate?.format('D MMM YYYY');

    const rangeTo = range?.to;
    const endDate = rangeTo === undefined ? DateTime.current() : DateTime.from(`${rangeTo}T23:59:59`);
    const endDateForView = endDate?.format('D MMM YYYY');

    return (
        <>
            <BetsListBet
                type='net-deposit'
                variant={accountSectionVariant}
            >
                <TransactionHistoryItemWrapper>
                    <TransactionNetDepositCurrency>
                        <span data-test='date'>{startDateForView}</span>
                    </TransactionNetDepositCurrency>
                    <TransactionNetDepositCurrency>
                        <span data-test='date'>{endDateForView}</span>
                    </TransactionNetDepositCurrency>
                    <TransactionNetDepositCurrency
                        isNegative={totalValue === null ? true : totalValue.isLessThanZero()}
                    >
                        <b>{usersState.money(totalValue)}</b>
                    </TransactionNetDepositCurrency>
                </TransactionHistoryItemWrapper>
            </BetsListBet>

            <NetDepositText>
                <I18n
                    langKey='account.transaction.list.net-deposit.text1'
                    defaultText='Your Net Deposit is the amount you have deposited minus the amount you have withdrawn over a period of time.'
                />
            </NetDepositText>

            <NetDepositText>
                <I18n
                    langKey='account.transaction.list.net-deposit.text2'
                    defaultText='Net Deposit = amount deposited - amount withdrawn.'
                />
            </NetDepositText>

            <NetDepositText>
                <I18n
                    langKey='account.transaction.list.net-deposit.text3'
                    defaultText='If your Net Deposit is negative (i.e. it has a minus in front of the figure), then you have withdrawn more than you have deposited.'
                />

                <NetDepositEmailInformation>
                    <I18n
                        langKey='account.transaction.list.net-deposit.email-info'
                        defaultText='If you have any concerns please contact '
                    />

                    <NetDepositEmail to={`mailto:${accountHelperMail}`}>{accountHelperMail}</NetDepositEmail>
                </NetDepositEmailInformation>
            </NetDepositText>
        </>
    );
});
